import { render, staticRenderFns } from "./OrdersFilter.vue?vue&type=template&id=d51bdb1c&scoped=true"
import script from "./OrdersFilter.vue?vue&type=script&lang=js"
export * from "./OrdersFilter.vue?vue&type=script&lang=js"
import style0 from "./OrdersFilter.vue?vue&type=style&index=0&id=d51bdb1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51bdb1c",
  null
  
)

export default component.exports